import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propBool, propFunc, propShape, propStr, } from '../../../../helpers/custom-prop-types';
import ConsultantSearchTab from '../Form/ConsultantSearchTab';
const ConsultantSearchHeader = (props) => {
    const { isOpen, isShowFilter, isTabDisable, onChangeSearch, search, tabs, totals, } = props;
    return (_jsxs("div", Object.assign({ className: 'search_header_wrapper' }, { children: [_jsx("div", { className: 'search_header_block' }), _jsx("div", Object.assign({ className: clsx('search_header_block_tab', !isShowFilter && 'is-hidden-filter') }, { children: _jsx(ConsultantSearchTab, { isDisabled: isTabDisable, isOpen: isOpen, isShowFilter: isShowFilter, onClick: onChangeSearch, search: search, tabs: tabs, totals: totals }) }))] })));
};
ConsultantSearchHeader.propTypes = {
    isOpen: propBool().isRequired,
    isShowFilter: propBool().isRequired,
    isTabDisable: propBool().isRequired,
    onChangeSearch: propFunc().isRequired,
    search: propStr().isRequired,
    tabs: propArrayShape().isRequired,
    totals: propShape().isRequired,
};
export default ConsultantSearchHeader;
